/**
 * @generated SignedSource<<c7855e307c800116c84ae3ac733d699d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrandMessageStatusEnum = "A" | "S" | "%future added value";
export type ChatBubbleTypeEnum = "CAROUSEL_COMMERCE" | "CAROUSEL_FEED" | "COMMERCE" | "IMAGE" | "PREMIUM_VIDEO" | "TEXT" | "WIDE" | "WIDE_ITEM_LIST" | "%future added value";
export type Ordering = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type BrandMessageTemplateFilter = {
  AND?: BrandMessageTemplateFilter | null;
  DISTINCT?: boolean | null;
  NOT?: BrandMessageTemplateFilter | null;
  OR?: BrandMessageTemplateFilter | null;
  adult_Exact?: boolean | null;
  chatBubbleType_Exact?: ChatBubbleTypeEnum | null;
  chatBubbleType_In?: ReadonlyArray<ChatBubbleTypeEnum> | null;
  created_Gte?: any | null;
  created_Lte?: any | null;
  isDormant_Exact?: boolean | null;
  modified_Gte?: any | null;
  modified_Lte?: any | null;
  search?: string | null;
  serviceStatus_Exact?: BrandMessageStatusEnum | null;
  serviceStatus_In?: ReadonlyArray<BrandMessageStatusEnum> | null;
};
export type BrandMessageTemplateOrder = {
  createTime?: Ordering | null;
  id?: Ordering | null;
  templateCode?: Ordering | null;
  templateName?: Ordering | null;
  updateTime?: Ordering | null;
};
export type BrandMessageTemplateWindowPaginatorRefreshQuery$variables = {
  filters?: BrandMessageTemplateFilter | null;
  order?: BrandMessageTemplateOrder | null;
  page?: number | null;
  pageSize?: number | null;
};
export type BrandMessageTemplateWindowPaginatorRefreshQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BrandMessageTemplateWindowPaginator_query">;
};
export type BrandMessageTemplateWindowPaginatorRefreshQuery = {
  response: BrandMessageTemplateWindowPaginatorRefreshQuery$data;
  variables: BrandMessageTemplateWindowPaginatorRefreshQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  },
  {
    "defaultValue": 1,
    "kind": "LocalArgument",
    "name": "page"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageSize"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  {
    "kind": "Variable",
    "name": "pageSize",
    "variableName": "pageSize"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "page",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandMessageTemplateWindowPaginatorRefreshQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "BrandMessageTemplateWindowPaginator_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandMessageTemplateWindowPaginatorRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandMessageTemplateConnection",
        "kind": "LinkedField",
        "name": "brandMessageTemplates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Pages",
            "kind": "LinkedField",
            "name": "pages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Page",
                "kind": "LinkedField",
                "name": "first",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Page",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCurrent",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Page",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Page",
                "kind": "LinkedField",
                "name": "next",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Page",
                "kind": "LinkedField",
                "name": "previous",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandMessageTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandMessageTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "templateCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "templateName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "chatBubbleType",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "852d8ed2a6a423d3af949f430d66e40e",
    "id": null,
    "metadata": {},
    "name": "BrandMessageTemplateWindowPaginatorRefreshQuery",
    "operationKind": "query",
    "text": "query BrandMessageTemplateWindowPaginatorRefreshQuery(\n  $filters: BrandMessageTemplateFilter\n  $order: BrandMessageTemplateOrder\n  $page: Int = 1\n  $pageSize: Int\n) {\n  ...BrandMessageTemplateWindowPaginator_query_36liK3\n}\n\nfragment BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection on BrandMessageTemplateConnection {\n  edges {\n    node {\n      id\n      createTime\n      templateCode\n      templateName\n      serviceStatus\n      chatBubbleType\n    }\n  }\n}\n\nfragment BrandMessageTemplateWindowPaginator_query_36liK3 on Query {\n  brandMessageTemplates(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {\n    totalCount\n    pages {\n      ...Pagination_pages\n    }\n    edges {\n      node {\n        id\n      }\n    }\n    ...BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection\n  }\n}\n\nfragment Pagination_pages on Pages {\n  first {\n    page\n  }\n  around {\n    page\n    isCurrent\n  }\n  last {\n    page\n  }\n  next {\n    page\n  }\n  previous {\n    page\n  }\n}\n"
  }
};
})();

(node as any).hash = "ee572b705518605cb32275cdf91fdd83";

export default node;
